var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"device-status"},[_c('font-awesome-icon',{staticClass:"device-status-icon",style:({ color: _vm.color }),attrs:{"icon":"circle","size":"1x"}}),_vm._v(" "+_vm._s(_vm.stateText)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }